export enum NetworkLogsCommunicationDirectionEnum {
  brokerToServer = 'brokerToServer',
  chargingStationToBroker = 'chargingStationToBroker',
}
